<div
	[ngClass]="
		cn(
			size() === 'sm' && 'pricing-sm',
			size() === 'base' && 'pricing-md',
			size() === 'lg' && 'pricing-lg',
			size() === 'xl' && 'pricing-xl'
		)
	"
	class="pricing"
>
	<div
		[ngClass]="cn(alignment() === 'self-end' && 'text-right')"
		class="pricing-combined"
		data-test-id="price"
	>
		@if (price() === null || requestPrice()) {
			<div class="flex items-center gap-1" data-test-id="price-type">
				<svg-icon
					class="icon-container icon-container-accent"
					src="assets/icons/icon-hourglass.svg"
				/>
				{{ 'components.pricing.request' | translate }}
			</div>
		} @else {
			@if (fromPrice() > 0 && fromPrice() > price()) {
				<vp-price
					[attr.data-test-id]="'price-from'"
					[currency]="currency()"
					[locale]="currentLang"
					[ngClass]="
						cn(
							alignment() === 'self-end' &&
								isHorizontal() === false &&
								'self-end',
							(alignment() === 'self-start' &&
								isHorizontal() === false) ||
								(isHorizontal() === true && 'self-start')
						)
					"
					[price]="fromPrice()"
					[striked]="true"
				/>
			}
			<div [class]="alignment()" class="flex">
				<vp-price
					[attr.data-test-id]="'price-final'"
					[currency]="currency()"
					[locale]="currentLang"
					[price]="price()"
					[size]="size()"
				/>
			</div>

			@if (isHorizontal() === false) {
				<ng-container [ngTemplateOutlet]="conditionsAndIndication" />
			}
		}
	</div>

	@if (isHorizontal() === true) {
		<ng-container [ngTemplateOutlet]="conditionsAndIndication" />
	}
</div>

<ng-template #conditionsAndIndication>
	@if (conditions()) {
		<div
			[ngClass]="
				cn(alignment() === 'self-end' && 'justify-end text-right')
			"
			class="pricing-conditions flex flex-row items-center gap-1"
		>
			<span data-test-id="price-label">
				@if (indication()) {
					<span>
						{{ 'components.pricing.indication' | translate }}
					</span>
				}
				{{ conditions() }}
			</span>

			@if (pricingToolTip()) {
				<vp-tooltip
					[fixedHeight]="false"
					alignment="bottom"
					iconSize="size-4"
					tooltipColor="text-dark-tertiary"
				>
					<span vpTooltipContent>
						<vp-pricing-summary
							[currency]="currency()"
							[dateRange]="
								pricingToolTip()?.dateRange ?? undefined
							"
							[items]="pricingToolTip()?.items ?? []"
							[occupancy]="
								pricingToolTip()?.occupancy ?? undefined
							"
							[taxes]="pricingToolTip()?.taxes ?? 0"
							[total]="pricingToolTip()?.total ?? 0"
						/>
					</span>
				</vp-tooltip>
			}
		</div>
	}
</ng-template>
